import { renderDate } from '~/common/components/CrudGrid/crudGridUtils';
import { formatCurrency } from '~/common/util/format';

import { formatName } from '../../common/utils/utils';

type AssetColumn = {
  fieldName: string;
  headerName: string;
  isNumeric?: boolean;
  renderCell?: (val: any) => React.ReactNode;
};

type AssetBorrower = {
  customerRecordId: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffixName?: string;
};

export const assetColumns: AssetColumn[] = [
  {
    fieldName: 'bankName',
    headerName: 'Asset Name',
  },
  {
    fieldName: 'accountNumber',
    headerName: 'Account Number',
    renderCell: (val: string) => (val === '' ? '-' : val),
  },
  {
    fieldName: 'assetType',
    headerName: 'Type of Asset',
  },
  {
    fieldName: 'balance',
    headerName: 'Balance',
    isNumeric: true,
    renderCell: (val: number) => formatCurrency(val),
  },
  {
    fieldName: 'verifiedDate',
    headerName: 'Statement Date',
    renderCell: (val: string | null) => renderDate(val),
  },
  {
    fieldName: 'borrowers',
    headerName: 'Associated Borrower(s)',
    renderCell: (val: AssetBorrower[]) =>
      val.map((borrower) => (
        <p key={borrower.customerRecordId}>
          {formatName(
            borrower.firstName,
            borrower.lastName,
            borrower.middleName,
            borrower.suffixName,
            true,
          )}
        </p>
      )),
  },
];
